import * as kinds from '@nostr/tools/kinds'
import { tagNameEquals } from '@/lib/tag'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import ExternalLink from '@/components/ExternalLink'

export default function IValue({ event, className }: { event: Event; className?: string }) {
  const { t } = useTranslation()
  const iValue = useMemo(() => {
    if (event.kind !== kinds.Comment) return undefined
    const iTag = event.tags.find(tagNameEquals('i'))
    return iTag ? iTag[1] : undefined
  }, [event])

  if (!iValue) return null

  return (
    <div className={cn('truncate text-muted-foreground', className)}>
      {t('Comment on') + ' '}
      {iValue.startsWith('http') ? (
        <ExternalLink url={iValue} className="underline inline" />
      ) : (
        <span>{iValue}</span>
      )}
    </div>
  )
}
